import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Link } from '@chegg/fanta'
import { Arrow } from '@chegg-wt/core/components/Icon'
import { AppState } from '@chegg-wt/core/state'
import { CITATION_LIST_NAME_LOWER_SINGLE } from '@chegg-wt/core/constants/citations'
import { colors, font, spacing } from '@chegg-ui/theme'
import {
  currentStyleSelector,
  currentProjectIdSelector,
} from '@chegg-wt/core/state/currentProject/selectors'
import { useRoutesContext } from '../RoutesContext'
import { AppLink } from '../AppLink'

const LeftArrow = styled(Arrow)`
  width: 20px;
  height: 17px;
  transform: rotate(90deg);
  fill: ${colors.link};
  stroke: ${colors.link};
  margin: ${spacing.px4};
`

const Anchor = styled(Link).attrs({
  role: 'heading',
})`
  display: flex;
  align-items: center;
  color: ${colors.link} !important;
  text-decoration: none;
  font-size: ${font.size.px16};
  font-weight: 600;
  padding-top: 16px;
`

interface Props {
  currentProjectId: string
  currentStyle: string
}

const BackLink: React.FC<Props> = ({ currentProjectId, currentStyle }) => {
  const routes = useRoutesContext()

  return (
    currentProjectId && (
      <AppLink
        route={routes.toBibliography({
          projectId: currentProjectId,
          style: currentStyle,
        })}
        data-test="back-to-citation-list-link"
      >
        <Anchor>
          <LeftArrow />
          Back to {CITATION_LIST_NAME_LOWER_SINGLE}
        </Anchor>
      </AppLink>
    )
  )
}

const mapStateToProps = (state: AppState) => ({
  currentProjectId: currentProjectIdSelector(state),
  currentStyle: currentStyleSelector(state),
})

export default connect(mapStateToProps)(BackLink)
